import React, { Suspense } from 'react';
import { Outlet, createRootRoute } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import CacheBuster from '../CacheBuster';

export const Route = createRootRoute({
  component: RootComponent,
});

// {
//   process.env.NODE_ENV === 'development' && (
//     <Suspense>
//       <TanStackRouterDevtools position="bottom-right" />
//     </Suspense>
//   )
// }
function RootComponent() {
  return (
    <CacheBuster>
      {({ loading }) => {
        if (loading) {
          return null;
        }
        return (
          <>
            <Outlet />
          </>
        );
      }}
    </CacheBuster>
  );
}
